import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./ResponsiveContainer.scss";
/**
 * @deprecated component has been moved, use ResponsiveContainer from @jti/ui instead
 */
export const ResponsiveContainer = ({ children, fullWidth = false, size, }) => {
    const currentClassNames = classNames("responsive-container", {
        "responsive-container--full-width": fullWidth,
        [`responsive-container--${size}`]: size,
    });
    return _jsx("div", { className: currentClassNames, children: children });
};
//# sourceMappingURL=ResponsiveContainer.js.map